<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				P&L Согласование
				<v-spacer></v-spacer>

				<v-text-field
					v-if="$store.getters.userHasRight('view_all_pl_approvals')"
					v-model="search"
					label="Поиск"
					clearable
					class="mb-4"
					single-line
					hide-details>
				</v-text-field>

				<v-btn icon class="mr-2" to="input/csv">
					<v-icon>add_circle</v-icon>
				</v-btn>
			</v-card-title>

			<!-- :pagination="pagination" -->
			<!-- :loading="loadingMore" -->
			<v-data-table
				:headers="headers"
				:items="data"
				:items-per-page="-1"
				hide-default-footer
				disable-sort
				show-expand
				single-expand
				:search="search"
				:no-data-text="loadingMore ? 'Загрузка...' : 'Ничего не нашлось'"
				:expanded.sync="expanded"
				@click:row="clickRow"
				item-key="id"
			>
				<template v-slot:item.status="{ item }">
					{{ textStatus(item.status) }}
				</template>
				<template v-slot:item.comments="{ item }">
					<v-btn icon
						   v-if="allowCommentsEdit(item)"
						   :disabled="item.loadingReport || item.loadingApprove"
						   @click.stop="dialogCommentsOpen(item)">
						<v-icon>edit</v-icon>
					</v-btn>
					<v-btn icon
						   v-if="allowCommentsRead(item)"
						   @click.stop="dialogCommentsOpen(item)">
						<v-icon>search</v-icon>
					</v-btn>
				</template>
				<template v-slot:item.actions="{ item }">
					<span class="text-no-wrap">
						<v-btn
							color="primary"
							class="ma-2"
							small
							:loading="item.loadingReport"
							v-if="allowReport(item)"
							@click.stop="reportReady(item)">
							Отправить
						</v-btn>
						<v-btn
							color="primary"
							class="ma-2"
							small
							:loading="item.loadingRecall"
							:disabled="item.loadingApprove"
							v-if="allowRecall(item)"
							@click.stop="recallPl(item)">
							Отозвать
						</v-btn>
						<v-btn
							color="primary"
							class="ma-2"
							small
							:loading="item.loadingApprove"
							:disabled="item.loadingReport || item.loadingRecall"
							v-if="allowApprove(item)"
							@click.stop="approveReady(item)">
							Утвердить
						</v-btn>
						<v-menu left offset-x slide-y
								v-if="allowPreview(item)">
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									icon
									:disabled="item.loadingReport || item.loadingApprove || item.loadingRecall"
									@click.stop>
									<v-icon>more_vert</v-icon>
								</v-btn>
							</template>
							<v-list dense>
								<v-subheader>Просмотр</v-subheader>
								<v-list-item	@click="combine('pl_month', 1, item)">
									<v-list-item-title>
										P&L за месяц
									</v-list-item-title>
								</v-list-item>
								<v-list-item	@click="combine('pl_year', 1, item)">
									<v-list-item-title>
										P&L за год
									</v-list-item-title>
								</v-list-item>
								<v-list-item	@click="combine('pl_month', 2, item)">
									<v-list-item-title>
										Метрики за месяц
									</v-list-item-title>
								</v-list-item>
								<v-list-item	@click="combine('pl_year', 2, item)">
									<v-list-item-title>
										Метрики за год
									</v-list-item-title>
								</v-list-item>
								<template v-if="allowRecalculateAllocations(item) || allowRecallApproved(item)">
									<v-subheader>Дополнительные действия</v-subheader>
									<v-list-item	@click="recalculateAllocations(item)"
													v-if="allowRecalculateAllocations(item)">
										<v-tooltip bottom max-width="300">
											<template v-slot:activator="{ on }">
												<v-list-item-title v-on="on">
													Рассчитать аллокации
												</v-list-item-title>
											</template>
											<span>
												Распределение расходов собственной прачечной и служебной столовой происходит автоматически при отправке отчета на утверждение GM. Если вы хотите рассчитать распределения сейчас, нажмите эту кнопку.
											</span>
										</v-tooltip>
									</v-list-item>
									<v-list-item	@click="recallApprovedPl(item)"
													v-if="allowRecallApproved(item)">
										<v-list-item-title>
											Отозвать утвержденный отчет
										</v-list-item-title>
									</v-list-item>
								</template>
							</v-list>
						</v-menu>
					</span>
				</template>
				<template v-slot:expanded-item="props">
					<td :colspan="props.headers.length" class="pa-0">
						<v-card tile dark>
							<v-card-text>
								<v-list dense>
									<template v-if="!props.item.reportedOn">
										<v-subheader>Данные системы учета</v-subheader>
										<v-list-item :to="{ name: 'PlInputCsv' }">
											<v-list-item-icon>
												<v-icon v-if="+props.item.csvReady" color="green">check_box</v-icon>
												<v-icon v-else color="red">check_box_outline_blank</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												CSV загружен
											</v-list-item-content>
										</v-list-item>
										<v-subheader>Данные от департаментов</v-subheader>
										<v-list-item to="input/rooms">
											<v-list-item-icon>
												<v-icon v-if="+props.item.rmReady" color="green">check_box</v-icon>
												<v-icon v-else color="red">check_box_outline_blank</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												Rooms
											</v-list-item-content>
										</v-list-item>
										<v-list-item to="input/fb">
											<v-list-item-icon>
												<v-icon v-if="+props.item.fbReady" color="green">check_box</v-icon>
												<v-icon v-else color="red">check_box_outline_blank</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												Food & Beverage
											</v-list-item-content>
										</v-list-item>
										<v-list-item to="input/hr">
											<v-list-item-icon>
												<v-icon v-if="+props.item.hrReady" color="green">check_box</v-icon>
												<v-icon v-else color="red">check_box_outline_blank</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												Human Resources
											</v-list-item-content>
										</v-list-item>
										<v-list-item to="input/ut">
											<v-list-item-icon>
												<v-icon v-if="+props.item.utReady" color="green">check_box</v-icon>
												<v-icon v-else color="red">check_box_outline_blank</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												Utilities
											</v-list-item-content>
										</v-list-item>
										<v-list-item to="input/hl">
											<v-list-item-icon>
												<v-icon v-if="+props.item.hlReady" color="green">check_box</v-icon>
												<v-icon v-else color="red">check_box_outline_blank</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												House Laundry
											</v-list-item-content>
										</v-list-item>
										<v-list-item to="input/sd">
											<v-list-item-icon>
												<v-icon v-if="+props.item.sdReady" color="green">check_box</v-icon>
												<v-icon v-else color="red">check_box_outline_blank</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												Staff Dining
											</v-list-item-content>
										</v-list-item>
									</template>
									<v-list-item v-if="props.item.reportedOn">
										Отчет отправлен: {{ props.item.reportedOn }}, {{ props.item.reportedBy }}
									</v-list-item>
									<v-list-item v-if="props.item.approvedOn">
										Отчет утвержден: {{ props.item.approvedOn }}, {{ props.item.approvedBy }}
									</v-list-item>
								</v-list>
							</v-card-text>
						</v-card>
					</td>
				</template>
			</v-data-table>
			<v-container v-if="!loadedAll && data.length > 1">
				<v-row justify="center">
					<v-col cols="1">
						<v-progress-circular
							indeterminate
							color="primary"
						></v-progress-circular>
					</v-col>
				</v-row>
			</v-container>
		</v-card>

		<v-dialog
			v-model="dialogComments.show"
			persistent
			max-width="1100px">
			<v-card>
				<v-card-title class="headline">
					Комментарии к P&L {{ dialogCommentsTitle }}
				</v-card-title>
				<v-card-text>
					<v-container fluid>
						<v-row>
							<v-col cols="12" v-if="allowCommentsEdit(dialogComments.item)">
								Комментарии будут отправлены вместе с отчетом в управляющую компанию
							</v-col>
							<v-col cols="12">

								<v-textarea
									auto-grow
									filled
									v-if="allowFcCommentsEdit(dialogComments.item) || dialogComments.item.fcComments"
									:readonly="!allowFcCommentsEdit(dialogComments.item)"
									:label="'FC ' + (dialogComments.item.reportedBy ?
										'(' + dialogComments.item.reportedBy + ')' : '')"
									v-model="dialogComments.item.fcComments">
								</v-textarea>

							</v-col>
							<v-col cols="12">

								<v-textarea
									auto-grow
									filled
									v-if="allowGmCommentsEdit(dialogComments.item) || dialogComments.item.gmComments"
									:readonly="!allowGmCommentsEdit(dialogComments.item)"
									:label="'GM ' + (dialogComments.item.approvedBy ?
										'(' + dialogComments.item.approvedBy + ')' : '')"
									v-model="dialogComments.item.gmComments">
								</v-textarea>

							</v-col>
						</v-row>
					</v-container>
					<template v-if="allowCommentsEdit(dialogComments.item)">
						<v-btn
							color="primary"
							class="ma-2"
							@click="dialogCommentsSave"
							:loading="dialogComments.btnLoading">
							Сохранить
						</v-btn>
						<v-btn
							color="secondary"
							class="ma-2"
							@click="dialogCommentsCancel">
							Отменить
						</v-btn>
					</template>
					<template v-else>
						<v-btn
							color="primary"
							class="ma-2"
							@click="dialogComments.show = false">
							Закрыть
						</v-btn>
					</template>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogConfirm.show"
			persistent
			max-width="600">
			<v-card>
		  		<v-card-title class="headline">
					Подтверждение
				</v-card-title>
		        <v-card-text>
					<v-container fluid>
						<v-row>
							<v-col class="mb-4" v-html="dialogConfirm.html">
							</v-col>
						</v-row>
					</v-container>
					<v-btn
						color="primary"
						class="ma-2"
						@click="confirmReportOrApprove(dialogConfirm.item.status)">
						Отправить
					</v-btn>
					<v-btn
						color="secondary"
						class="ma-2"
						v-if="dialogConfirm.askForComments"
						@click="addComment">
						Добавить комментарий
					</v-btn>
					<v-btn
						color="secondary"
						class="ma-2"
						@click="dialogConfirm.show = false">
						Назад
					</v-btn>
		        </v-card-text>
	      	</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
	tr.scroll-loading,
	tr.scroll-loading td {
		height: auto;
		border: none;
	}
</style>

<script>
	import {c} from '../../lib/const'
	import {api} from '../../lib/api'
	import {display} from '../../lib/display'
	import {getMonthName} from '../../js/common.js'
	import _ from 'lodash'

	export default {
		data: () => ({
			loadingMore: false,
			loadedAll: false,
			dialogComments: {
				index: 0,
				show: false,
				btnLoading: false,
				item: {
					id: 0,
					hotelCode: '',
					year: 2000,
					mon: 1,
					status: 0,
					reportedBy: '',
					approvedBy: '',
					fcComments: '',
					gmComments: ''
				}
			},
			dialogConfirm: {
				index: 0,
				text: '',
				show: false,
				item: null
			},
			data: [],
			search: '',
			headers: [
				{
					text: 'Код отеля',
					value: 'hotelCode',
					align: 'center',
					width: '10%',
				},
				{
					text: 'Год',
					value: 'year',
					align: 'center',
					width: '10%',
				},
				{
					text: 'Месяц',
					value: 'mon',
					align: 'center',
					width: '10%',
				},
				{
					text: 'Статус',
					value: 'status',
					align: 'center',
					width: '30%',
				},
				{
					text: 'Комментарии',
					value: 'comments',
					align: 'center',
					width: '20%',
				},
				{
					text: 'Действия',
					value: 'actions',
					align: 'center',
					width: '20%',
				},
			],
			expanded: [],
		}),
		computed: {
			dialogCommentsTitle() {
				let i = this.dialogComments.item
				return i.hotelCode + ' ' + ' ' + getMonthName(i.mon, 'Ul') + ' ' + i.year
			},
		},
		created() {
			this.loadMore()
			this.throttledLoadMore = _.throttle(this.loadMore, 1000)
			this.debouncedLoadMore = _.debounce(this.loadMore, 1000)
		},
		mounted() {
			window.onscroll = this.scrollTrigger

			// window.onscroll = () => {
			// 	this.scrollTrigger()
			// }
		},
		watch: {
			search() {
				this.scrollTrigger()
			}
		},
		methods: {
			clickRow (row) {
				let i = this.expanded.indexOf(row)
				if (i >= 0) {
					this.expanded.splice(i, 1)
				}
				else {
					this.expanded = []
					this.expanded.push(row)
				}
			},
			scrollTrigger() {
				let scrolled = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - 250
				// console.log('------------')
				// console.log('document.documentElement.scrollTop', document.documentElement.scrollTop)
				// console.log('window.innerHeight', window.innerHeight)
				// console.log('document.documentElement.offsetHeight', document.documentElement.offsetHeight)
				//
				// console.log(document.documentElement.scrollTop + window.innerHeight, document.documentElement.offsetHeight - 250)
				// console.log('scrolled', document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - 250)
				if (scrolled) this.debouncedLoadMore()
			},
			allowFcCommentsEdit(item) {
				if (item.status == c.PL_STATUS_INITIAL && this.$store.getters.userHasRight('pl_input')) return true
				else return false
			},
			allowGmCommentsEdit(item) {
				if (item.status == c.PL_STATUS_FC_REPORTED && this.$store.getters.userHasRight('pl_approve')) return true
				else return false
			},
			allowCommentsEdit(item) {
				return this.allowGmCommentsEdit(item) || this.allowFcCommentsEdit(item)
			},
			allowCommentsRead(item) {
				if (!this.allowCommentsEdit(item)
					&& item.status > c.PL_STATUS_INITIAL
					&& (item.fcComments || item.gmComments)
				) {
					return true
				}
				else return false
			},
			allowRecalculateAllocations(item) {
				if (item.status == c.PL_STATUS_INITIAL && this.$store.getters.userHasRight('pl_input')) return true
				else return false
			},
			allowReport(item) {
				if (item.status == c.PL_STATUS_INITIAL
					&& this.$store.getters.userHasRight('pl_input')
					&& +item.rmReady
					&& +item.fbReady
					&& +item.hrReady
					&& +item.utReady
					&& +item.sdReady
					&& +item.hlReady
				) {
					return true
				}
				else return false
			},
			allowRecall(item) {
				if (item.status == c.PL_STATUS_FC_REPORTED && this.$store.getters.userHasRight('pl_input')) return true
				else return false
			},
			allowRecallApproved(item) {
				if (item.status == c.PL_STATUS_FINAL && this.$store.getters.userHasRight('pl_recall_approved')) return true
				else return false
			},
			allowApprove(item) {
				if (item.status == c.PL_STATUS_FC_REPORTED && this.$store.getters.userHasRight('pl_approve')) return true
				else return false
			},
			reportReady(item) {
				this.dialogConfirm.show = true
				this.dialogConfirm.item = item
				this.dialogConfirm.index = this.data.indexOf(item)
				this.dialogConfirm.html = 'Отчет будет отправлен на утверждение GM.<br><br>'
				if (!item.fcComments) this.dialogConfirm.html += 'Комментарии к отчету отсутствуют.<br>'
				this.dialogConfirm.html += 'Подтвержаете отправку?'
				this.dialogConfirm.askForComments = !item.fcComments
			},
			confirmReportOrApprove(status) {
				if (status == c.PL_STATUS_INITIAL) {
					this.reportPl()
				}
				else {
					this.approvePl()
				}
			},
			reportPl() {
				this.dialogConfirm.show = false

				let index = this.dialogConfirm.index
				this.data[index].loadingReport = true

				api.post('pl/report', {
					id: this.dialogConfirm.item.id,
					hotelCode: this.dialogConfirm.item.hotelCode,
					year: this.dialogConfirm.item.year,
					mon: this.dialogConfirm.item.mon
				})
				.then(response => {
					this.data[index].status = c.PL_STATUS_FC_REPORTED
					this.data[index].reportedBy = response.data.reportedBy
					this.data[index].reportedOn = response.data.reportedOn
					this.data[index].loadingReport = false
				}, error => {})
			},
			recallPl(item) {
				this.$store.dispatch('dialogConfirm', {
					title: 'Подтверждение',
					message: 'Отозвать отчет?'
				})
				.then(confirm => {
					if (confirm) {
						item.loadingRecall = true
						api.post('pl/recall', {
							id: item.id,
						})
						.then(response => {
							item.status = c.PL_STATUS_INITIAL
							item.reportedBy = ''
							item.reportedOn = ''
							item.loadingRecall = false
						}, error => {})
					}
				})
			},
			recallApprovedPl(item) {
				this.$store.dispatch('dialogConfirm', {
					title: 'Подтверждение',
					message: 'Отозвать отчет?'
				})
				.then(confirm => {
					if (confirm) {
						this.$store.dispatch('dialogLoadingStart')
						api.post('pl/recall_approved', {
							id: item.id,
						})
						.then(response => {
							item.status = c.PL_STATUS_INITIAL
							item.reportedBy = ''
							item.reportedOn = ''
							this.$store.dispatch('dialogLoadingStop')
						}, error => {})
					}
				})
			},
			addComment() {
				this.dialogConfirm.show = false
				this.dialogCommentsOpen(this.dialogConfirm.item)
			},
			approveReady(item) {
				this.dialogConfirm.show = true
				this.dialogConfirm.item = item
				this.dialogConfirm.index = this.data.indexOf(item)
				this.dialogConfirm.html = 'Отчет будет отправлен в управляющую компанию, а'
				this.dialogConfirm.html += ' отчеты по департаментам будут отправлены руководителям департаментов.<br><br>'
				if (!item.gmComments) this.dialogConfirm.html += 'Комментарии к отчету отсутствуют.<br>'
				this.dialogConfirm.html += 'Подтвержаете отправку?'
				this.dialogConfirm.askForComments = !item.gmComments
			},
			approvePl(item) {
				this.dialogConfirm.show = false

				let index = this.dialogConfirm.index
				this.data[index].loadingApprove = true

				api.post('pl/approve', {
					id: this.dialogConfirm.item.id,
				})
				.then(response => {
					this.data[index].status = c.PL_STATUS_FINAL
					this.data[index].approvedBy = response.data.approvedBy
					this.data[index].approvedOn = response.data.approvedOn
					this.data[index].loadingApprove = false
				}, error => {})
			},
			recalculateAllocations(item) {
				this.$store.dispatch('dialogLoadingStart')
				api.post('pl/recalculate_allocations', {
					hotelCode: item.hotelCode,
					year: item.year,
					mon: item.mon
				})
				.then(response => {
					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')
				}, error => {
					this.$store.dispatch('dialogLoadingStop')
				})
			},
			combine(reportCode, reportType, item) {
				var month

				if (reportCode == 'pl_month') month = item.year + '-' + item.mon.padStart(2, '0')
				else month = item.year + '-12'


				let p = {
					reportCode: reportCode,
					userId: this.$store.getters.userId,
					hotelCode: item.hotelCode,
					dept: 0,
					format: 'pdf',
					type: reportType,
					unit: 1000,
					showNullLines: false,
					showInitialData: true,
					showForecast: true,
					lan: 'en',
					recalculate: true,
					month: month,
					year: item.year
				}

				display.open(p)
			},
			dialogCommentsOpen(item) {
				this.dialogComments.index = this.data.indexOf(item)
				for(let i in item) {
					this.dialogComments.item[i] = item[i]
				}
				this.dialogComments.show = true
			},
			dialogCommentsCancel() {
				this.dialogComments.show = false
				this.dialogComments.item.fcComments = this.data[this.dialogComments.index].fcComments
				this.dialogComments.item.gmComments = this.data[this.dialogComments.index].gmComments
			},
			dialogCommentsSave() {
				let i = this.dialogComments.item
				let form = {
					id: i.id
				}

				if (this.allowFcCommentsEdit(i)) {
					form.fcComments = i.fcComments
				}
				if (this.allowGmCommentsEdit(i)) {
					form.gmComments = i.gmComments
				}

				this.dialogComments.btnLoading = true

				api.post('pl/set_comments', form)
				.then(response => {
					let index = this.dialogComments.index
					this.data[index].fcComments = i.fcComments
					this.data[index].gmComments = i.gmComments
					this.dialogComments.show = false
					this.dialogComments.btnLoading = false
				}, error => {})
			},
			allowPreview(item) {
				if (this.$store.getters.userHasRight('pl_input')) return true
				else if (item.status > c.PL_STATUS_INITIAL) return true
				else return false
			},
			textStatus(status) {
				if (status == c.PL_STATUS_INITIAL) return 'Создан'
				if (status == c.PL_STATUS_FC_REPORTED) return 'Утверждение GM'
				if (status == c.PL_STATUS_FINAL) return 'Отправлен'
			},
			loadMore () {
				if (!this.loadedAll && !this.loadingMore) {
					// console.log('loadMore')
					this.loadingMore = true

					api.post('pl/get_approval_table', {
						offset: this.data.length,
					})
					.then(response => {
						// console.log('loadMore Response', response.data.reports[0].id, response.data.reports[response.data.reports.length - 1].id)
						response.data.reports.forEach(r => {
							r.loadingReport = false
							r.loadingRecall = false
							r.loadingApprove = false
							this.data.push(r)
						})
						this.loadedAll = response.data.all
						this.loadingMore = false
						this.scrollTrigger()
					}, error => {})
				}
			},
		}
	}
</script>
